import { Button } from "@carbon/react";
import { Link } from "react-router-dom";

import tickCircleBlueIcon from "../../../assets/icons/tick-circle-blue.svg";

export const View = (props) => {
  return (
    <div className="onboarding-section onboarding-step-6 flex-box flex-container col justify-content--between">
      <div className="flex-box flex-container justify-content--center align-items--center">
        <div className="flex-container justify-content--center align-items--center">
          <div className="onboarding-section__header">
            <img src={tickCircleBlueIcon} alt="onboarding complete icon" />
          </div>

          <div className="flex-container col align-items--center">
            <h3 className="step-title font-ctm--bold">
              Thanks for activating your account
            </h3>
            <p>
              <span className="feedback-request--description">
                You can now make live transactions. If you need to change
                something,{" "}
                <Link to="/feedback" className="switchapp-link">
                  please let us know
                </Link>
                . We will reach out if we need additional information.
              </span>
            </p>
          </div>
        </div>
      </div>

      <p className="switchapp-legal-agreements">
        By activating your profile you agree with the{" "}
        <Link to="/terms-of-service">Terms and Conditions</Link>,{" "}
        <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
        <Link to="/cookie-policy">Cookie Policy</Link> of
        <b className="company-name font-ctm--bold">
          {" "}
          SwitchApp Tech Solutions Limited.
        </b>
      </p>
    </div>
  );
};
